
import { Vue } from "vue-facing-decorator";
import { mathFix } from "@/services/mathServices";

export class DeclarationFormEngine extends Vue {

    get self() {
        return this
    }

    mathFix(number, precision = 2) {
        return mathFix(number, precision)
    }

    functions = []
    dicoKeyWithFunctions = {}

    fields = {}

    dataLoaded = false

    setFields(fields) {
        this.fields = fields
    }

    readForm(form) {
        // if (!this.company) {
        //     return
        // }
        this.dataLoaded = false
        const fields = form.tables.flatMap(x => x.rows).filter(x => x.values).flatMap(x => x.values)
        const data = {}
        for (let f of fields) {
            if (f.skipSave) {
                continue
            }
            switch (f.type) {
            case "string": {
                if (f.default) {
                    // debugger
                    if (typeof f.default === 'object') {
                        try {
                            this.functions.push({
                                process: f.default?.body,
                                function: new Function(f.default.args, f.default.body)
                            })
                        } catch(e) {
                            console.error(f)
                            console.error(e)
                            debugger
                        }
                        data[f.key] = ""
                    } else if (f.default.startsWith("this.")) {
                        let variable = f.default.split("this.")
                        data[f.key] = data[f.key] || this.accessObject(variable[1])
                    } else {
                        data[f.key] = data[f.key] || f.default
                    }
                } else {
                    data[f.key] = data[f.key] || ""
                }
                break
            }
            case "date": {
                data[f.key] = data[f.key] || ""
                break
            }
            case "title":
            case "text":
            case "empty":
                break
            case "number":
                break
            case "radio":
            case "textarea" :
                data[f.key] = data[f.key] || ""
                break
            default: {
                if (f.default) {
                    if (typeof f.default === 'object') {
                        this.dicoKeyWithFunctions[f.key] = true
                        try {
                            this.functions.push({
                                process: f.default?.body,
                                function: new Function(f.default.args, f.default.body)
                            })
                        } catch(e) {
                            console.error(f)
                            console.error(e)
                            debugger
                        }
                        data[f.key] = ""
                    } else if (f.default.startsWith("this.")) {
                        let variable = f.default.split("this.")
                        data[f.key] = data[f.key] || this.accessObject(variable[1])
                    } else {
                        data[f.key] = data[f.key] || f.default
                    }
                } else {
                    data[f.key] = data[f.key] || 0
                }
                break
            }
            }
        }
        this.dataLoaded = true
        return data
    }

    accessObject(path) {
        return path.split('.').reduce(function(o, k) {
            return o && o[k];
        }, this);
    }

    update() {
        for (let f of this.functions) {
            try {
                if (f.process.includes("self.fields['AC'] = ")) {
                    debugger
                }
                f.function(this)
                // console.log("AC", this.fields['AC'])
            } catch(e) {
                // console.error(f)
                console.error(e)
                debugger
            }
        }
    }

    reloadField(field) {
        if (field.onChange) {
            if (field.onChange.args && field.onChange.body) {
                (new Function(field.onChange.args ,field.onChange.body))(this)
            } else {
                debugger // git-ignore
            }
        }
        this.update()
    }

    filterForm() {

        const fieldsToTest = {
            declarationFormKey: "3517SCA12-2022-v1",
            values:{},
            references: {}
        }
        for (const key in this.fields) {
            if (this.dicoKeyWithFunctions[key]) {
                fieldsToTest.references[key] = this.fields[key]
            } else {
                if (this.fields[key] !== 0) {
                    fieldsToTest.values[key] = this.fields[key]
                }
            }
        }

        // this.saveFile(fieldsToTest)

        return fieldsToTest
    }
}
